import { useNavigate } from "react-router-dom";

import { serverUrl, client, publishedAssetUrl } from "../../config";
import GridItem from "../../partials/gridItem";
import { parseSummary } from "../../partials/posts/postHelpers";

export default function VideoItem(props) {
  const navigate = useNavigate();

  let path =
    client === "equans"
      ? `${serverUrl}/${props.item.field_featured_image}`
      : `${serverUrl}/api/video/thumbnail?mid=${props.item?.mid}`;

  if (props.item.field_media_oembed_video) {
    path = publishedAssetUrl(
      "video",
      props.item?.id ?? props.item?.nid,
      props.item.thumbnail,
    );
  }

  return (
    <>
      <GridItem
        xs={props.creator ? 6 : 12}
        sm={props.creator ? 3 : 6}
        md={props.creator ? 2 : 3}
        itemClass="video"
        item={props.item}
        bundle={props.item?.bundle}
        id={props.item?.id ?? props.item?.nid}
        title={props.item?.title}
        field_body={props.creator ? "" : (props.item?.summary ?? "")}
        category_label={props.item.category_labels}
        created={props.item?.created}
        hasImg={true}
        imgSrc={path}
        alt={`Poster for Video ${props.item?.id ?? props.item?.nid}`}
        cardActionArea={true}
        creator={props.creator}
        cardActionCallBack={
          props.creator ? () => {} : () => navigate(`/videos/view/${props.item?.id ?? props.item?.nid}`)
        }
        contentType={props.contentType}
        shareEnabled
        route={"videos"}
        field_access_token={props.item.access_token}
        sharePrompt={`This is a public link that enables you to share the video with your client, no login required.`}
      ></GridItem>
    </>
  );
}
